<template>
  <v-card class="ma-0 px-1" width="100%" flat>
    <v-app-bar flat class="my-0 mb-6 py-1 px-2" dense height="30">
      <v-toolbar-title class="mt-4 me-4">{{ $t($route.name) }}</v-toolbar-title>
      <div v-if="!isMobile && !isTablet" style="width: 230px">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </div>
      <v-spacer />
      <v-btn
        v-if="selected.length > 0 && !isMobile"
        outlined
        @click="deletDialog = true"
        class="mt-4 ms-2"
        color="pink"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t("remove") }}
        </p>
        <v-icon> mdi-trash-can-outline </v-icon>
      </v-btn>
      <v-menu offset-y>
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            outlined
            class="mt-4 px-1 ms-2"
            color="grey darken-2"
            height="32"
            v-bind="attrs"
            v-on="on"
            style="min-width: 35px !important; padding: 0 !important"
          >
            <!-- <p class="mb-0 me-2">
              {{$t('more')}}
            </p> -->
            <v-icon> mdi-dots-vertical </v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <log
            v-if="
              $store.state.permissions && $store.state.permissions.includes('logList')
            "
            ref="logRef"
            :type-prop="typeForm"
            :listProp="true"
            mode-prop="button"
          />
          <v-list-item v-if="isMobile || isTablet" link @click="getItems">
            <v-list-item-icon>
              <v-icon>mdi-refresh</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('refresh')" />
          </v-list-item>
          <v-list-item v-if="isMobile || isTablet" link @getAllRows="getAllRows">
            <export-excel
              ref="refExcel"
              :data="excelItems"
              worksheet="abriron.com"
              name="data.xls"
              type="xls"
              class="float-left d-flex"
              :title="$store.state.abrName"
              :total-prop="pageCount"
              :page-prop="excelPage"
              @getAllRows="getAllRows"
            >
              <v-list-item-icon>
                <v-icon>mdi-file-excel-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="$t('excel')" />
            </export-excel>
          </v-list-item>
          <v-list-item v-if="isMobile || isTablet" link @click="printDialog = true">
            <v-list-item-icon>
              <v-icon>mdi-printer-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('print')" />
          </v-list-item>
          <v-list-item v-if="isMobile || isTablet" link @click="goTo(type)">
            <v-list-item-icon>
              <v-icon>mdi-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t(type)" />
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="getItems"
        class="mt-4 px-1 ms-2"
        color="grey darken-2"
        height="32"
        style="min-width: 35px !important; padding: 0 !important"
      >
        <!-- <p class="mb-0 me-2">
          {{$t('refresh')}}
        </p> -->
        <v-icon> mdi-refresh </v-icon>
      </v-btn>
      <export-excel
        v-if="!isMobile && !isTablet"
        ref="refExcel"
        :data="excelItems"
        worksheet="abriron.com"
        name="data.xls"
        type="xls"
        class="float-left"
        :title="$store.state.abrName"
        :total-prop="pageCount"
        :page-prop="excelPage"
        @getAllRows="getAllRows"
      >
        <v-btn outlined class="mt-4 ms-2" color="grey darken-2 " height="32">
          <p class="font-weight-thin mb-0 me-2">
            {{ $t("excel") }}
          </p>
          <v-icon> mdi-file-excel-outline </v-icon>
        </v-btn>
      </export-excel>
      <v-btn
        outlined
        @click="filter = true"
        class="mt-4 ms-2"
        color="grey darken-2 "
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t("filter") }}
        </p>
        <v-icon> mdi-filter-outline </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="printDialog = true"
        class="mt-4 ms-2"
        color="grey darken-2"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t("print") }}
        </p>
        <v-icon> mdi-printer-outline </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="goTo(type)"
        class="mt-4 ms-2"
        color="primary"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t(type) }}
        </p>
        <v-icon> mdi-plus </v-icon>
      </v-btn>
    </v-app-bar>
    <v-row v-if="isMobile || isTablet" class="mx-0">
      <v-col class="mb-4 px-2" cols="12">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </v-col>
    </v-row>
    <v-col
      cols="12"
      class="px-2"
      :class="{ 'mt-2': !isMobile && !isTablet, 'mt-0': isMobile || isTablet }"
    >
      <v-data-table
        v-if="headers"
        :height="isMobile || isTablet || mobileShow ? 323 : tableHeight"
        fixed-header
        v-model="selected"
        :headers="showHeaders"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        multi-sort
        :page.sync="page"
        dense
        :show-select="showSelect"
        item-key="id"
        class="mb-2 td-hide-border"
        style="border: 1px solid #e3e3e3; border-radius: 6px"
        :footer-props="{
          showFirstLastPage: false,
          itemsPerPageOptions: [10, 25, 50, 100, 500],
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-plus',
          nextIcon: 'mdi-minus',
        }"
      >
        <template v-slot:item.actions="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ attrs, on }">
              <v-btn color="primary" v-bind="attrs" icon v-on="on">
                <v-icon medium> mdi-dots-vertical </v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item
                link
                :disabled="item.head.lock == 'active'"
                @click="edit(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-clipboard-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('edit')" />
              </v-list-item>
              <v-list-item
                v-if="item.head"
                v-clipboard:copy="$baseURL + '/' + item.head.type + '/edit/' + item.id"
                link
              >
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('copy-link')" />
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:item.user.name="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div v-if="item.user" color="primary" dark v-bind="attrs" v-on="on">
                {{ item.user.firstname }} {{ item.user.lastname }}
              </div>
            </template>
            <span>{{ item.time }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.head.type="{ item }">
          <v-icon size="15" v-if="item.head && item.head.lock == 'active'">
            mdi-lock
          </v-icon>
          <v-btn
            v-if="item.head"
            :loading="loading"
            class="ma-0 px-1"
            :color="
              item.head.type === 'remittance'
                ? 'pink'
                : item.head.type === 'receipt'
                ? 'teal'
                : 'blue'
            "
            plain
            @click="
              item.head.type !== 'initial' &&
              item.head.type !== 'production' &&
              item.head.lock != 'active'
                ? edit(item)
                : null
            "
          >
            {{ $t(item.head.type) }} {{ $t("number") }} : {{ item.head.id }}
          </v-btn>
          <v-chip
            v-if="item.head && item.head.invoice"
            :color="
              item.head.type === 'remittance'
                ? 'pink'
                : item.head.type === 'receipt'
                ? 'teal'
                : 'blue'
            "
            small
            outlined
            label
            @click="invoice(item)"
          >
            {{ $t(item.head.invoice.type) }} - {{ $t("number") }}
            {{ item.head.invoice.number }} (id:{{ item.head.invoice.id }})
            {{
              item.head && item.head.invoice && item.head.invoice.customer
                ? " - " + item.head.invoice.customer.name
                : ""
            }}
          </v-chip>
          <v-chip
            v-if="item.head && item.head.production"
            color="teal"
            small
            outlined
            label
            @click="invoice(item)"
          >
            {{ $t(item.head.production.type) }} - {{ $t("number") }}
            {{ item.head.production.number }} (id:{{ item.head.production.id }})
          </v-chip>
        </template>
        <template v-slot:item.price="{ item }">
          {{ $numberFormat(item.price, "currency", $store.state.currency.decimal) }}
        </template>
        <template v-slot:item.invoiceArticle.fee="{ item }">
          {{
            $numberFormat(
              item?.invoiceArticle?.fee ?? 0,
              "currency",
              $store.state.currency.decimal
            )
          }}
        </template>
        <template v-slot:item.in="{ item }">
          {{ $numberFormat(item.in, "number") }}
          {{
            item.unit2 && item.in
              ? "(" + item.countUnit + " " + item.unit2.fame + ")"
              : ""
          }}
        </template>
        <template v-slot:item.out="{ item }">
          {{ $numberFormat(item.out, "number") }}
          {{
            item.unit2 && item.out
              ? "(" + item.countUnit + " " + item.unit2.fame + ")"
              : ""
          }}
        </template>
        <template v-slot:item.checked_count="{ item }">
          {{ $numberFormat(item.checked_count, "number") }}
        </template>
        <template v-slot:item.id="{ item }">
          <a @click="item.head.lock != 'active' && edit(item)">
            {{ item.id }}
          </a>
        </template>
        <template v-slot:item.row="{ item }">
          <a @click="item.head.lock != 'active' && edit(item)">
            {{ parseInt(items.indexOf(item)) + parseInt(from) }}
          </a>
        </template>
        <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template>
        <template v-slot:item.sumCount="{ item }">
          {{ $numberFormat(item.sumCount.toFixed(3), 3) }}
          <!-- {{ $numberFormat(item.sumCount, 3) }} {{ item }} -->
        </template>
        <template v-slot:item.sumAmount="{ item }">
          {{ $numberFormat(item.sum.toFixed($store.state.currency.decimal)) }}
        </template>
        <template v-slot:footer.prepend>
          <v-col v-show="!isMobile" cols="1" class="pa-0" style="margin-top: -10px">
            <v-text-field
              v-model.number="page"
              :label="$t('goToPage')"
              min="1"
              :max="pageCount"
              type="number"
              outlined
              height="32"
              hide-details
              hide-spin-buttons
              dense
              :suffix="'  /  ' + pageCount"
            />
          </v-col>
        </template>
        <template v-slot:body.append>
          <tr :class="{ 'v-data-table__mobile-table-row': isMobile }">
            <td
              :colspan="`${isMobile ? 6 : 7}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              <strong>{{ $t("sum") }}</strong>
            </td>
            <td
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ isMobile ? $t("in") + ":" : "" }}
              <!-- {{ $numberFormat(totals.in.toFixed(3)) }} -->
              {{ $numberFormat(totals.in, "number") }}
            </td>
            <td
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ isMobile ? $t("out") + ":" : "" }}
              <!-- {{ $numberFormat(totals.out.toFixed(3)) }} -->
              {{ $numberFormat(totals.out, "number") }}
            </td>
            <td
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ $t("remain") }} :
              <!-- {{ $numberFormat((+totals.in - +totals.out).toFixed(3)) }} -->
              <!-- {{ $numberFormat(+totals.in - +totals.out, "number") }} -->
              {{
                parseFloat((+totals.in - +totals.out).toFixed(10)).toLocaleString(
                  "en-US",
                  {
                    maximumFractionDigits: 10,
                  }
                )
              }}
            </td>
            <td
              :colspan="`${isMobile ? 6 : 4}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            />
          </tr>
        </template>
      </v-data-table>
    </v-col>
    <v-row />
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="printDialog"
      width="70%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="printDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <print
            :header-prop="showHeaders"
            :items-prop="items"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="filter"
      width="70%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="filter = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("filter") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col cols="12" md="4">
            <autocomplete
              v-model="product"
              type="product"
              :title="$t('product')"
              :outlined="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <autocomplete
              v-model="entrepot"
              :title="$t('entrepot')"
              type="entrepot"
              :outlined="true"
              :multiple="true"
              :filter="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <autocomplete
              v-model="branch"
              title="branch"
              type="branch"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <template>
              <v-text-field
                id="fromId"
                v-model="fromDate"
                :label="$t('from') + ' ' + $t('date')"
                outlined
                dense
                clearable
              />
              <date-picker
                v-model="fromDate"
                element="fromId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                auto-submit
                :color="
                  this.$vuetify.theme.themes[
                    this.$vuetify.theme.isDark ? 'dark' : 'light'
                  ].primary
                "
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col cols="12" md="4">
            <template>
              <v-text-field
                id="toId"
                v-model="toDate"
                :label="$t('until') + ' ' + $t('date')"
                outlined
                dense
                clearable
              />
              <date-picker
                v-model="toDate"
                element="toId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                :min="fromDate"
                auto-submit
                :color="
                  this.$vuetify.theme.themes[
                    this.$vuetify.theme.isDark ? 'dark' : 'light'
                  ].primary
                "
                @close="setDate"
              />
            </template>
          </v-col>

          <v-col cols="12" md="4">
            <v-select
              v-model="selectedHeaders"
              :items="headers"
              label="Select Columns"
              height="30"
              dense
              outlined
              multiple
              return-object
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 2" small>
                  <span>{{ item.text }}</span>
                </v-chip>
                <v-chip v-if="index === 1" small>
                  <span>(+{{ selectedHeaders.length - 2 }} {{ $t("other") }})</span>
                </v-chip>
              </template>
            </v-select>
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="statusControll"
              :label="$t('statusControll')"
              :items="statusItems"
              height="30"
              dense
              outlined
              clearable
              item-value="value"
              item-text="text"
            />
          </v-col>
          <!-- add more filtere items-->
          <v-col cols="12" md="4">
            <v-select
              v-model="documentType"
              :label="$t('type')"
              :items="documentTypeItems"
              height="30"
              dense
              outlined
              clearable
              item-value="value"
              item-text="text"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="invoiceType"
              :label="$t('type') + ' ' + $t('invoice')"
              :items="invoiceTypeItems"
              height="30"
              dense
              outlined
              clearable
              item-value="value"
              item-text="text"
            />
          </v-col>
          <v-col cols="12" md="4">
            <autocomplete
              v-model="registerar"
              :title="$t('registerar')"
              type="partners"
              :multiple="true"
              :filter="true"
            />
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn class="mx-0" color="primary" @click="getItems">
                {{ $t("filter") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left mx-0"
                @click="filter = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="taskDialog"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="taskDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("task") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="deletDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img class="mx-auto" width="200" src="@/assets/stop.svg" />
        </v-col>
        <v-col class="mt-3 pr-7">
          <p class="mx-auto font-weight-medium">
            {{ $t("are-you-sure-delete-this-case") }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn v-if="selected.length > 0" color="primary" @click="removegroup">
                {{ $t("remove") }}
              </v-btn>
              <v-btn v-if="selected.length == 0" color="primary" @click="remove">
                {{ $t("remove") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </v-card>
</template>

<script>
import Task from "../task/task";
import Print from "../../components/general/Print/Index";
import General from "../../../../Mixins/general";
import autocomplete from "../../components/general/patial/autocomplete";
export default {
  name: "ProductTurnover",
  components: {
    Snakbar: () => import("../../components/general/snakbar/snakbar"),
    Print,
    autocomplete,
    Task,
  },
  mixins: [General],
  props: ["input", "refId", "productProp", "entrepotProp", "idProp", "mobileShow"],
  data: () => ({
    documentType: null,
    documentTypeItems: [],
    invoiceType: null,
    invoiceTypeItems: [],
    registerar: null,
    statusItems: [],
    excelItems: [],
    selected: [],
    pageCount: 1,
    page: 1,
    printDialog: false,
    deletDialog: false,
    filter: false,
    sumAmount: 0,
    sumCount: 0,
    statusControll: null,
    entrepot: null,
    product: null,
    productStatus: null,
    productStatusItems: null,
    model: null,
    from: 1,
    taskDialog: null,
    tag: null,
    temp: null,
    deleteItem: null,
    sellStatus: null,
    fromDate: null,
    toDate: null,
    items: [],
    sortBy: [],
    dialog: null,
    timer: 0,
    totalItems: 0,
    snakbar: false,
    typeForm: null,
    taskId: null,
    snakbarText: null,
    loading: true,
    options: {
      itemsPerPage: 5,
    },
    headers: null,
    type: null,
    search: null,
    selectedHeaders: [],
    headersMap: null,
    fin4: null,
    given: null,
  }),
  computed: {
    showSelect() {
      if (!this.isMobile) {
        return true;
      } else {
        return false;
      }
    },
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    showHeaders() {
      var app = this;
      return this.headers.filter(function (s) {
        if (app.$route.name === "productCountTurnover") {
          if (s.value === "price" || s.value === "sumAmount") {
          } else {
            return app.selectedHeaders.includes(s);
          }
        } else if (
          app.$route.name === "productTurnover" ||
          app.$route.name === "productTurnoverDetails"
        ) {
          if (s.value === "sumCount" || s.value === "sumAmount") {
          } else if (
            s.value === "invoiceArticle.fee" &&
            app.$route.name !== "productTurnoverDetails"
          ) {
          } else {
            return app.selectedHeaders.includes(s);
          }
        } else {
          if (app.$route.name === "productCountTurnover" && s.value === "sumAmount") {
          } else {
            return app.selectedHeaders.includes(s);
          }
        }
      });
    },
    totals: function () {
      const totals = this.items.reduce(
        (acc, d) => {
          acc.in += d.in ? parseFloat(d.in) : 0;
          acc.out += d.out ? parseFloat(d.out) : 0;
          return acc;
        },
        {
          in: 0,
          out: 0,
        }
      );
      return totals;
    },
  },
  watch: {
    idProp() {
      this.getItems();
    },
    refId(val, oldVal) {
      // this.items = []
      this.getItems();
    },
    model() {
      this.$emit("input", this.model);
    },
    entrepotProp(val) {
      this.getItems();
    },
    selected() {
      this.$emit("input", this.selected.text);
      if (this.selected.length > 0) {
        this.model = this.selected[0].text;
        this.temp = this.selected[0].text;
      }
      this.dialog = false;
    },
    search() {
      var app = this;
      app.loading = true;
      app.page = 1;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        app.getItems();
      }, 1000);
    },
    options: {
      handler() {
        var app = this;
        app.sortBy = [];
        app.options.sortBy.map(function (value, key) {
          const index = app.headers.findIndex((h) => h.value === value);
          app.sortBy.push(app.headers[index].table);
        });
        this.getItems();
      },
      deep: true,
    },
    sortBy() {
      const index = this.headers.findIndex((h) => h.value === this.sortBy);
      if (index > -1) {
        this.sortBy = this.headers[index].table;
      }
    },
  },
  beforeMount() {
    if (this.$route.name === "purchaseList") {
      this.type = "purchase";
    }
    if (this.$route.name === "presaleList") {
      this.type = "presale";
    }
    if (this.$route.name === "sellList") {
      this.type = "sell";
    }
    if (this.$route.name === "purchaseReturnList") {
      this.type = "purchaseReturn";
    }
    if (this.$route.name === "sellReturnList") {
      this.type = "sellReturn";
    }
    this.headers = [
      {
        text: this.$t("actions"),
        align: "start",
        sortable: false,
        value: "actions",
        width: 20,
      },
      {
        text: this.$t("row"),
        align: "start",
        sortable: false,
        value: "row",
        width: 20,
      },
      {
        text: this.$t("type"),
        sortable: true,
        value: "head.type",
        table: "entrepot_head.type",
      },
      {
        text: this.$t("entrepot"),
        sortable: true,
        value: "entrepot.name",
        table: "entrepots.name",
      },
      {
        text: this.$t("date"),
        sortable: true,
        value: "head.date",
        table: "entrepot_head.date",
      },
      {
        text: this.$t("product"),
        sortable: true,
        value: "product.name",
        table: "products.name",
      },
      {
        text: this.$t("in"),
        sortable: true,
        value: "in",
        table: "entrepot_article.in",
      },
      {
        text: this.$t("out"),
        sortable: true,
        value: "out",
        table: "entrepot_article.out",
      },
      {
        text: this.$t("countCheckByStorekeeper"),
        sortable: true,
        value: "checked_count",
        table: "entrepot_article.checked_count",
      },
      {
        text: this.$t("unit"),
        sortable: false,
        value: "unit.fame",
      },
      {
        text: this.$t("fee"),
        sortable: true,
        value: "price",
        table: "entrepot_article.price",
      },
      //add sellPrice in /details
      {
        text: this.$t("sellPrice"),
        sortable: true,
        value: "invoiceArticle.fee",
        table: "invoice_articles.fee",
      },
      {
        text: this.$t("sumCount"),
        sortable: false,
        value: "sumCount",
      },
      {
        text: this.$t("sumAmount"),
        sortable: false,
        value: "sumAmount",
      },
      {
        text: this.$t("registerar"),
        sortable: false,
        value: "user.name",
      },
    ];
    this.headersMap = this.headers;
    this.selectedHeaders = this.headers;
    this.productStatusItems = [
      {
        value: "active",
        text: this.$t("active"),
      },
      {
        value: "deactive",
        text: this.$t("deactive"),
      },
    ];
    if (this.input) {
      this.model = this.input;
    }
    this.statusItems = [
      {
        value: "LeavingTheWarehouse",
        text: this.$t("LeavingTheWarehouse"),
      },
      {
        value: "LogInWarehouse",
        text: this.$t("LogInWarehouse"),
      },
      {
        value: "storekeeperCountError",
        text: this.$t("storekeeperCountError"),
      },
    ];
    //for filter
    this.documentTypeItems = [
      { value: "initial", text: this.$t("initial") },
      { value: "remittance", text: this.$t("remittance") },
      { value: "warehouseHandling", text: this.$t("warehouseHandling") },
      { value: "receipt", text: this.$t("receipt") },
    ];
    this.invoiceTypeItems = [
      { value: "purchase", text: this.$t("purchase") },
      { value: "sell", text: this.$t("sell") },
      { value: "returnPurchase", text: this.$t("returnPurchaseList") },
      { value: "returnSell", text: this.$t("returnSellList") },
    ];
  },
  mounted() {},
  methods: {
    openDeleteDialog(item) {
      this.deleteItem = item;
      this.deletDialog = true;
    },
    openTaskDialog(item) {
      this.refId = item.rel_id;
      this.taskId = item.id;
      this.taskDialog = true;
    },
    isEnabled(slot) {
      return this.enabled === slot;
    },
    edit(item) {
      this.$router.push({ name: item.head.type + "Edit", params: { id: item.head.id } });
    },
    invoice(item) {
      if (item.head.type === "production") {
        // this.$router.push({ name: item.head.production.type + 'Edit', params: { id: item.head.production.id } })
      } else {
        // this.$router.push({ name: item.head.invoice.type + 'Edit', params: { id: item.head.invoice.uid } })
      }
    },
    getItems() {
      var app = this;
      app.filter = false;
      app.loading = true;
      var productId = app.productProp ? app.productProp.id : null;
      productId = this.$route.params.id ? this.$route.params.id : productId;
      app.$axios
        .get(this.$endpoint + "productsreport", {
          params: {
            product_id: app.product ? app.product.id : null,
            productProp_id: productId,
            entrepotProp: !app.entrepot ? app.entrepotProp : null,
            entrepot: app.entrepot,
            search: app.search,
            page: app.allRows ? app.excelPage : app.options.page,
            refId: app.refId,
            statusControll: app.statusControll,
            branch: app.branch,
            idProp: app.idProp,
            type: app.type,
            fromDate: app.fromDate,
            toDate: app.toDate,
            report: "turnover",
            sortBy: app.sortBy,
            status: app.productStatus,
            options: app.options,
            tag: app.tag,
            documentType: app.documentType,
            invoiceType: app.invoiceType,
            registerar: app.registerar,
            typeForm: app.typeForm,
            name: app.$route.name,
          },
        })
        .then((res) => {
          res = res.data;
          if (!app.allRows) {
            app.items = res.data;
            app.totalItems = res.total;
            app.pageCount = res.last_page;
            app.from = res.from;
            app.creatExcelData(res.data);
          } else {
            app.generateExcellForAllData(res.data, res.last_page);
          }
          if (app.options.page === 1) {
            app.sumAmount = 0;
            app.sumCount = 0;
          }
          app.items.map(function (value, key) {
            if (value.in > 0 || value.out > 0) {
              if (value.in > 0) {
                app.sumAmount =
                  parseFloat(app.sumAmount) +
                  parseFloat(value.price) * parseFloat(value.in);
                app.sumCount = parseFloat(app.sumCount) + parseFloat(value.in);
              } else {
                app.sumCount = parseFloat(app.sumCount) - parseFloat(value.out);
                app.sumAmount =
                  parseFloat(app.sumAmount) -
                  parseFloat(value.price) * parseFloat(value.out);
              }
            }
            value.sum = app.sumAmount;
            value.sumCount = app.sumCount;
          });
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    remove() {
      var app = this;
      if (!app.deleteItem) return false;
      app.loading = true;
      app.$axios
        .delete(this.$endpoint + "invoice/" + this.deleteItem.id)
        .then((res) => {
          res = res.data;
          app.deletDialog = false;
          app.deleteItem = null;
          app.getItems();
        })
        .catch((err) => {
          this.deletDialog = false;
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    removegroup() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "invoice", {
          params: {
            deleteItems: app.selected,
          },
        })
        .then((res) => {
          res = res.data;
          app.deletDialog = false;
          app.deleteItem = null;
          app.selected = [];
          app.getItems();
        })
        .catch((err) => {
          this.deletDialog = false;
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    creatExcelData(data, type = "page") {
      var app = this;
      if (type === "page") {
        app.excelItems = [];
      }
      data.map(function (d) {
        app.excelItems.push({
          id: d.id,
          type: app.$t(d.head.type) + " " + app.$t("number") + " " + d.head.id,
          warehouse: d.entrepot ? d.entrepot.name : "",
          date: d.head ? d.head.date : "",
          product: d.product ? d.product.name : "",
          unit: d.unit ? d.unit.fame : "",
          in: d.in,
          out: d.out,
          fee: d.price,
          sellPrice: d?.invoiceArticle?.fee ?? "",
        });
      });
    },
  },
};
</script>

<style scoped>
::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep
  .v-text-field--outlined.v-input--dense.v-text-field--outlined
  > .v-input__control
  > .v-input__slot {
  min-height: 32px !important;
}
</style>
